export const PRICING_PLAN_OPTION = {
  LITE: "LITE",
  PREMIUM: "PREMIUM",
  STANDARD: "STANDARD",
};
